export default "__VITE_ASSET__cc9ec4e0__"